// removed by extract-text-webpack-plugin
module.exports = {"PrivacyMessage":"_1DKDz2vu","Legal":"_1q9L0gYJ","ButtonContainer":"_1MctSJn1","Button":"_331yuiPp"};


//////////////////
// WEBPACK FOOTER
// ./src/components/messages/privacy/privacy-message-component.styles.scss
// module id = 566
// module chunks = 0